<template>
  <AttentionDialog
    :title="$t('title.moveToCategory')"
    img="move_folder.svg"
    img-width="151px"
    is-open
    @close="$emit('close')"
  >
    <div class="q-pa-lg">
      <AppSelect
        v-model="newFolder"
        :options="folders"
        :option-disable="filterFolders"
        option-label="title"
        option-value="guid"
        emit-value
        map-options
      />
    </div>
    <template #footer>
      <AppButton
        v-close-popup
        :label="$t('button.cancel')"
        class="col"
        color="white"
        text-color="black"
        outline
      />
      <AppButton
        :label="$t('button.move')"
        :loading="loading"
        label-class="q-px-sm"
        class="col"
        icon-right="fl:folder_send_light"
        icon-right-size="24px"
        @click="onMoveFolder"
      />
    </template>
  </AttentionDialog>
</template>

<script>
import AppSelect from 'common/components/AppSelect';
import AppButton from 'common/components/buttons/AppButton';
import AttentionDialog from 'common/components/dialogs/AttentionDialog';
import handleError from 'common/helpers/handleError';
import { mapGetters } from 'vuex';

export default {
  name: 'MoveDialog',
  components: {
    AttentionDialog,
    AppButton,
    AppSelect,
  },
  props: {
    folderType: {
      type: String,
      required: true,
      validator: (value) => Object.values(ENUMS.FOLDER_TYPES).includes(value),
    },
    entry: {
      type: Object,
      required: true,
    },
  },
  emits: ['move'],
  data() {
    return {
      newFolder: undefined,
      loading: false,
    };
  },
  computed: {
    ...mapGetters('dashboard', ['getFolders']),
    folders() {
      return this.getFolders(this.folderType);
    },
  },
  methods: {
    async onMoveFolder() {
      try {
        this.loading = true;
        await this.$axios.put(`folders/${this.folderType}/${this.newFolder}/entry`, {
          entryGuid: this.entry.guid,
        });
        this.$emit('move');
      } catch (error) {
        handleError(error);
      } finally {
        this.loading = false;
      }
    },
    filterFolders(item) {
      return this.entry.folders.some((folder) => item.guid === folder.guid);
    },
  },
};
</script>
